
import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import Select from 'react-select';
import { getFromApi } from '../utilities/NetUtilities';
import { buildUrl } from '../helper/handler';


FiltroNote.propTypes = {
    action: PropTypes.func,
    setMessageFromApi: PropTypes.func,
}

function FiltroNote({ action, setMessageFromApi }) {

    const [tutteNote, setTutteNote] = useState(false);
    const [lavoratore, setLavoratore] = useState("")
    const [tipo, setTipo] = useState("")
    const [sediScelte, setSediScelte] = useState([])
    const [lavoratori, setLavoratori] = useState([])
    const [tipi, setTipi] = useState([])
    const [sedi, setSedi] = useState([])
    const [inizio, setInizio] = useState("");
    const [fine, setFine] = useState("");

    useEffect(() => {
        function getLavoratori() {
            const organizzazioneMap = JSON.parse(window.sessionStorage.getItem("organizzazione"));
            if (organizzazioneMap) {
                const setLavoratoriFromApi = (data) => {
                    setLavoratori(data.lavoratori.map(lavoratore => ({ "value": lavoratore.id, "label": lavoratore.nomeCognome })));
                };
                const urlLavoratori = buildUrl('lavoratori', { organizzazione: organizzazioneMap.nome, tipo: organizzazioneMap.tipo });
                getFromApi(urlLavoratori, setLavoratoriFromApi, setMessageFromApi);
            }
        }

        function getSedi() {
            const organizzazioneMap = JSON.parse(window.sessionStorage.getItem("organizzazione"));
            if (organizzazioneMap) {
                const setSediFromApi = (data) => {
                    setSedi(data.sedi.map(sede => ({ "value": sede.id, "label": sede.descrizione })));
                }
                const url = buildUrl('sedi', { organizzazione: organizzazioneMap.nome, tipo: organizzazioneMap.tipo });
                getFromApi(url, setSediFromApi, setMessageFromApi);
            }
        }

        function getTipiNota() {
            const organizzazioneMap = JSON.parse(window.sessionStorage.getItem("organizzazione"));
            if (organizzazioneMap) {
                const setTipiFromApi = (data) => {
                    setTipi(data.tipi.map(tipo => ({ "value": tipo, "label": tipo })));
                };
                const urlTipiNota = buildUrl('tipinota', { organizzazione: organizzazioneMap.nome, tipo: organizzazioneMap.tipo });
                getFromApi(urlTipiNota, setTipiFromApi, setMessageFromApi);
            }
        }
        getLavoratori();
        getTipiNota();
        getSedi();
    }, [setMessageFromApi])

    const formatDate = (dateString) => {
        let formattedDate = "";
        if (dateString) {
            const parts = dateString.split('-');
            if (parts.length === 3) {
                formattedDate = `${parts[2]}/${parts[1]}/${parts[0]}`;
            } else {
                formattedDate = dateString;
            }
        }
        return formattedDate;
    };

    const filtroTutte = (tutte) => {
        const valoreLavoratore = lavoratore ? lavoratore.value : "";
        const valoreTipo = tipo ? tipo.value : "";
        setTutteNote(tutte);
        action(tutte, valoreLavoratore, valoreTipo, sediScelte.map((sede => sede.value)), formatDate(inizio), formatDate(fine))
    }

    const filtroLavoratore = (lavoratore) => {
        const valoreLavoratore = lavoratore ? lavoratore.value : "";
        const valoreTipo = tipo ? tipo.value : "";
        setLavoratore(lavoratore);
        action(tutteNote, valoreLavoratore, valoreTipo, sediScelte.map((sede => sede.value)), formatDate(inizio), formatDate(fine))
    }

    const filtroTipo = (tipo) => {
        const valoreTipo = tipo ? tipo.value : "";
        const valoreLavoratore = lavoratore ? lavoratore.value : "";
        setTipo(tipo);
        action(tutteNote, valoreLavoratore, valoreTipo, sediScelte.map((sede => sede.value)), formatDate(inizio), formatDate(fine))
    }

    const filtroSedi = (sediScelte) => {
        const valoreLavoratore = lavoratore ? lavoratore.value : "";
        const valoreTipo = tipo ? tipo.value : "";
        setSediScelte(sediScelte);
        action(tutteNote, valoreLavoratore, valoreTipo, sediScelte.map((sede => sede.value)), formatDate(inizio), formatDate(fine))
    }

    const filtroInizo = (inizio) => {
        const valoreLavoratore = lavoratore ? lavoratore.value : "";
        const valoreTipo = tipo ? tipo.value : "";
        setInizio(inizio);
        action(tutteNote, valoreLavoratore, valoreTipo, sediScelte.map((sede => sede.value)), formatDate(inizio), formatDate(fine))
    }

    const filtroFine = (fine) => {
        const valoreLavoratore = lavoratore ? lavoratore.value : "";
        const valoreTipo = tipo ? tipo.value : "";
        setFine(fine);
        action(tutteNote, valoreLavoratore, valoreTipo, sediScelte.map((sede => sede.value)), formatDate(inizio), formatDate(fine))
    }


    return (
        <div className="formGroup" id="filtro">
            <div className="date-container">
                <div className="date-field">
                    <label htmlFor="inizio" className="inEvidenza">inizio</label>
                    <input
                        className='form-control'
                        id="inizio-filtro"
                        type="date"
                        value={inizio}
                        onChange={(event) => {
                            filtroInizo(event.target.value);
                        }}
                    />
                </div>
                <div className="date-field">
                    <label htmlFor="fine" className="inEvidenza">fine</label>
                    <input
                        className='form-control'
                        id="fine-filtro"
                        type="date"
                        value={fine}
                        onChange={(event) => {
                            filtroFine(event.target.value);
                        }}
                    />
                </div>
            </div>
            <div className="date-container">
                <div className="date-field">
                    <label htmlFor="lavoratore" className="inEvidenza">lavoratore</label>
                    <Select
                        name="lavoratore"
                        instanceId="lavoratore-filtro"
                        options={lavoratori}
                        onChange={filtroLavoratore}
                        placeholder="Seleziona..."
                        value={lavoratore}
                        isClearable
                    />
                </div>
                <div className="date-field">
                    <label htmlFor="tipo" className="inEvidenza">tipo</label>
                    <Select
                        name="tipo"
                        instanceId="tipo-filtro"
                        options={tipi}
                        onChange={filtroTipo}
                        placeholder="Seleziona..."
                        value={tipo}
                        isClearable
                    />
                </div>
                <div className="date-field">
                    <label htmlFor="sedi" className="inEvidenza">sedi</label>
                    <Select
                        name="sedi"
                        instanceId="sedi-filtro"
                        options={sedi}
                        onChange={filtroSedi}
                        placeholder="Seleziona..."
                        value={sediScelte}
                        isMulti
                    />
                </div>
            </div>
            <div className="date-container">
                <div className="checkbox">
                    <input
                        className='form-control'
                        id="tuttenote"
                        type="checkbox"
                        checked={tutteNote}
                        onChange={(event) => {
                            filtroTutte(event.target.checked);
                        }}
                    />
                    <label htmlFor="tuttenote" className="inEvidenza">visualizza note non attive</label>
                </div>
            </div>
        </div>)
}

export default FiltroNote;